<template lang="html">
  <div>
    <br>
    <v-layout align-center justify-center>
      <v-flex xs12 lg8>

        <!-- Número de alunos de graduação participantes -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Número de alunos de graduação participantes" 
            :value="this.projetoPesquisa.numAlunosGraduacao ? this.projetoPesquisa.numAlunosGraduacao : '-'"  
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Número de alunos de especialização participantes -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Número de alunos de especialização participantes" 
            :value="this.projetoPesquisa.numAlunosEspecializacao ? this.projetoPesquisa.numAlunosEspecializacao : '-'" 
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Possui vínculo com a iniciação científica -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Possui vínculo com a iniciação científica"
            :value="this.projetoPesquisa.vinculoIniciacaoCientifica != null ? (this.projetoPesquisa.vinculoIniciacaoCientifica ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Possui interface com outras áreas -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field
            label="Possui interface com outras áreas"
            :value="this.projetoPesquisa.interfaceOutrasAreas != null ? (this.projetoPesquisa.interfaceOutrasAreas ? 'Sim' : 'Não') : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Áreas de interface com o projeto -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true">
          <v-flex xs12>
            <label>Áreas de interface com o projeto</label>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Desenvolvimento Tecnológico" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true && projetoPesquisa.areaDesenvTec === true">
          <v-flex xs12>
            <p class="black--text body-1">• Desenvolvimento Tecnológico</p>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Ensino" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true && projetoPesquisa.areaEnsino === true">
          <v-flex xs12>
            <p class="black--text body-1">• Ensino</p>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Extensão" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true && projetoPesquisa.areaExtensao === true">
          <v-flex xs12>
            <p class="black--text body-1">• Extensão</p>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Outras" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true && projetoPesquisa.areaOutros === true">
          <v-flex xs12>
            <p class="black--text body-1">• {{ projetoPesquisa.especAreaOutros }}</p>
          </v-flex>
        </v-layout>

        <br>

      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Editar" -->
      <v-btn color="primary" @click="toEditar()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Editar</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn color="primary" @click="toAvancar()">Avançar</v-btn>

    </v-card-actions>

  </div>
</template>

<script>
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Edita a aba "Outras Informações".
    toEditar: function () {
      this.$router.push({ name: 'EditarProjetoPesquisaOutrasInformacoes', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaArquivos', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaContatos', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    }
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-readonly-field': ReadonlyField
  }
}
</script>



// WEBPACK FOOTER //
// outras-informacoes.vue?55fd5d88